export default __webpack_public_path__ + "static/media/036-fog.b1167c6b.svg";